import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { mergeMap, map, catchError } from 'rxjs/operators';
import * as PayableSpotActions from '../actions/payable-spots.actions';
import * as UiActions from '../../ui/actions/ui.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { PaymentsService } from '../services/payroll.service';
import { PayableSpot } from '../models/payroll.model';

@Injectable()
export class PayableSpotEffects {
    constructor(private actions$: Actions, private paymentService: PaymentsService, private store: Store<AppState>) { }


    loadPayableSpots$ = createEffect(() => this.actions$.pipe(
        ofType(PayableSpotActions.loadPayableSpots),
        mergeMap(({ organizationId, clientId, payrollId, weekNumber, isApproved }) => this.paymentService.getPayableSpots(organizationId, clientId, payrollId, weekNumber, isApproved).pipe(
            map((spots: PayableSpot[]) => PayableSpotActions.loadPayableSpotsSuccess({ spots })),
            catchError(() => of( /* handle error action */))
        ))
    ));

    // Handles the bulk save triggered by confirmEmployeeSpots().
    // Uses mergeMap so concurrent saves for different employees don't cancel each other.
    bulkUpdatePayableSpots$ = createEffect(() => this.actions$.pipe(
        ofType(PayableSpotActions.bulkUpdatePayableSpots),
        mergeMap(({ organizationId, clientId, payrollId, employeeId, spots }) =>
            this.paymentService.updatePayableSpotsBulk(organizationId, clientId, payrollId, employeeId, spots).pipe(
                // Pass employeeId through to success so SpotDetailsComponent can identify its result
                map(result => PayableSpotActions.bulkUpdatePayableSpotsSuccess({
                    employeeId,
                    created: result.created,
                    updated: result.updated,
                    deletedIds: result.deleted
                })),
                catchError(error => of(PayableSpotActions.bulkUpdatePayableSpotsFailure({ error })))
            )
        )
    ));

    updatePayableSpot$ = createEffect(() => this.actions$.pipe(
        ofType(PayableSpotActions.updatePayableSpot),
        mergeMap(({ organizationId, clientId, payrollId, spotId, spot }) =>
            this.paymentService.updatePayableSpot(organizationId, clientId, payrollId, spotId, spot).pipe(
                map((updatedSpot: PayableSpot) => PayableSpotActions.updatePayableSpotSuccess({ updatedSpot })),
                catchError(error => of(UiActions.serviceCallFailure({
                    action: PayableSpotActions.updatePayableSpot, error
                })))
            )
        )
    ));
}
